// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__CHQwh","name":"Header_name__32kw0","birthday":"Header_birthday__2wOvV","skeleton":"Header_skeleton__1El7a"};